import React from 'react';
import { MBSnackbar } from 'components/components/MBSnackbar';

export type SetSnackbarInfoPayloadType = Omit<SnackbarProps, 'setSnackbarInfo'>;

export interface SnackbarProps {
  isOpen: boolean;
  setSnackbarInfo: React.Dispatch<
    React.SetStateAction<SetSnackbarInfoPayloadType>
  >;
  otherProps?: Record<string, any>;
}

const Snackbar: React.FC<SnackbarProps> = (props) => {
  const { isOpen, setSnackbarInfo, otherProps } = props;

  const handleClose = () => {
    setSnackbarInfo((prevInfo) => ({ ...prevInfo, isOpen: false }));
  };

  return (
    // @ts-expect-error // TODO: fix types
    <MBSnackbar
      id="product_catalog_message_box"
      open={isOpen}
      autoHideDuration={4000}
      onClose={handleClose}
      {...otherProps}
    />
  );
};

export default Snackbar;
